import { useSelector, useDispatch } from "react-redux";
import { useTokenService } from "../../tokenService"
import { RootState } from "../../utils/store";
import { HubManager } from "./HubManager";
import { useEffect } from "react";


export const useHubManager = (): void => {
    const dispatch = useDispatch();
    const tokenService = useTokenService();
    const apiEndpoint = useSelector((state: RootState) => state.settings.apiEndpoint);
    const hubManager = HubManager.getInstance(tokenService);

    useEffect(() => {
        // Set the dispatch function so HubManager can use it
        HubManager.setDispatch(dispatch);
        
        if (apiEndpoint) {
            // Reset connection failures when endpoint changes (e.g., user changes settings)
            hubManager.resetConnectionFailures();
            
            hubManager.initializeConnection(apiEndpoint)
                .then(() => {
                    // Connection successful - no need to log as HubManager already logs
                })
                .catch(error => {
                    // Error already handled in HubManager, no need to log again
                });
        }
        return () => {
            hubManager.stopConnection();
        }
    }, [apiEndpoint, dispatch, hubManager]);
}